import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../../Icons/CloseIcon';

import './ThumbnailButton.scss';

const ThumbnailButton = ({ name, submitText, submittingText, submitting, handleClick, secondaryClick }) => (
  <div className="thumbnail-button">
    <div className="thumbnail-button-content">
      <div className={`actions-wrapper ${submitting && 'submitting'}`} onClick={handleClick}>
        <div className="icon-wrapper">
          <CloseIcon />
        </div>
        <div className="submit-text">{submitting ? submittingText : submitText}</div>
      </div>
      <div
        className="name-wrapper"
        onClick={(e) => {
          e.stopPropagation();
          secondaryClick();
        }}
      >
        {name}
      </div>
    </div>
  </div>
);
ThumbnailButton.defaultProps = {
  secondaryClick: () => {},
};
ThumbnailButton.propTypes = {
  name: PropTypes.string.isRequired,
  submitText: PropTypes.string.isRequired,
  submittingText: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  secondaryClick: PropTypes.func,
};
export default ThumbnailButton;
